import React from 'react';
import { Bar } from 'react-chartjs-2';

function DemographicsBarChart({ data, label, title }) {
  const chartData = {
    labels: data.map(d => d[label]),
    datasets: [{
      label: title,
      data: data.map(d => d.count),
      backgroundColor: 'rgba(75, 192, 192, 0.6)',
      borderColor: 'rgba(75, 192, 192, 1)',
      borderWidth: 1,
    }],
  };

  return <Bar data={chartData} options={{ indexAxis: 'y', responsive: true }} />;
}

export default DemographicsBarChart;